import { useLogger } from '@tumelo/logging';
import { useState } from 'react';
// based off of https://usehooks.com/useLocalStorage/
export const useLocalStorage = (key, defaultValue) => {
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === 'undefined') {
            return defaultValue;
        }
        try {
            const item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        }
        catch (error) {
            logger.logError(error, { extra: { where: 'useLocalStorage' } });
            return defaultValue;
        }
    });
    const logger = useLogger();
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            logger.logError(error, { extra: { where: 'useLocalStorage' } });
        }
    };
    return [storedValue, setValue];
};
export const useSessionStorage = (key, defaultValue) => {
    const logger = useLogger();
    const [storedValue, setStoredValue] = useState(() => {
        if (typeof window === 'undefined') {
            return defaultValue;
        }
        try {
            const item = window.sessionStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        }
        catch (error) {
            logger.logError(error, { extra: { where: 'useSessionStorage' } });
            return defaultValue;
        }
    });
    const setValue = (value) => {
        try {
            // Allow value to be a function so we have same API as useState
            const valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            logger.logError(error, { extra: { where: 'useSessionStorage' } });
        }
    };
    return [storedValue, setValue];
};
